module.exports = __webpack_public_path__ + "img/whatsapp.7061f03d.png";